import styled from 'styled-components';

export const GeneralErrorsPageStyled = styled.div`
    height: 90%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
